import React, { useState } from "react";
import emailjs from "emailjs-com";
import { useParams } from "react-router-dom";
import Seo from "../components/Seo";
import PageIntro from "../components/qa/PageIntro";
import { getResumeUrl } from "../content/assets";
import { contact, getCopy } from "../content/portfolio";

export default function LocalizedContact() {
  const { locale = "de" } = useParams();
  const copy = getCopy(locale).contact;
  const [values, setValues] = useState({ name: "", email: "", subject: "", message: "" });
  const [status, setStatus] = useState("");

  async function submit(event) {
    event.preventDefault();
    if (Object.values(values).some(value => !value.trim())) return setStatus("error");
    const serviceId = process.env.REACT_APP_EMAILJS_SERVICE_ID;
    const templateId = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
    const publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;
    if (!serviceId || !templateId || !publicKey) return setStatus("error");
    try {
      await emailjs.send(
        serviceId,
        templateId,
        { from_name: values.name, from_email: values.email, subject: values.subject, message: values.message },
        publicKey
      );
      setValues({ name: "", email: "", subject: "", message: "" });
      setStatus("success");
    } catch {
      setStatus("error");
    }
  }

  return (
    <div className="page-wrapper">
      <Seo locale={locale} metadata={copy.seo} path="/contact" />
      <PageIntro titleId="contact-title" eyebrow={copy.subhead} title={copy.title} intro={copy.intro} />
      <section className="content-wrapper qa-contact-page" aria-label={copy.title}>
        <div className="qa-contact-layout">
          <form className="input-wrapper" onSubmit={submit}>
            {[["name", copy.name, "text"], ["email", copy.email, "email"], ["subject", copy.subject, "text"]].map(([name, label, type]) => (
              <div className="form-group" key={name}>
                <label className="bodycopy" htmlFor={name}>{label}</label>
                <input className="form-input" id={name} name={name} type={type} inputMode={name === "email" ? "email" : undefined} autoComplete={name === "name" ? "name" : name === "email" ? "email" : "off"} required value={values[name]} onChange={event => setValues({ ...values, [name]: event.target.value })} />
              </div>
            ))}
            <div className="form-group">
              <label className="bodycopy" htmlFor="message">{copy.message}</label>
              <textarea className="form-input" id="message" name="message" rows="6" autoComplete="off" required value={values.message} onChange={event => setValues({ ...values, message: event.target.value })} />
            </div>
            {status && <p className={`bodycopy ${status === "success" ? "text-success" : "text-error"}`} role={status === "success" ? "status" : "alert"} aria-live={status === "success" ? "polite" : undefined}>{status === "success" ? copy.success : copy.error}</p>}
            <button className="button-primary bodycopy" type="submit">{copy.submit}</button>
          </form>
          <nav className="qa-contact-links" aria-label={copy.direct}>
            <a className="bodycopy" href={`mailto:${contact.email}`}>{contact.email}</a>
            <a className="bodycopy" href={contact.linkedin} target="_blank" rel="noreferrer">LinkedIn<span className="visually-hidden"> {locale === "de" ? "öffnet in einem neuen Tab" : "opens in a new tab"}</span></a>
            <a className="bodycopy" href={getResumeUrl(locale)} target="_blank" rel="noreferrer">{locale === "de" ? "Lebenslauf" : "Résumé"}<span className="visually-hidden"> {locale === "de" ? "öffnet in einem neuen Tab" : "opens in a new tab"}</span></a>
          </nav>
        </div>
      </section>
    </div>
  );
}
